/**
 * Calculate the final price after applying a price modifier.
 * @param {Object} options - The calculation options.
 * @param {string} options.priceModifierType - The type of price modifier ('PERCENTAGE' or 'AMOUNT').
 * @param {number} options.priceModifierValue - The value of the price modifier.
 * @param {number} options.variantPrice - The original variant price.
 * @returns {number} The final price after applying the modifier.
 */
export const calculateFinalPriceModifier = ({ priceModifierType, priceModifierValue, variantPrice }) => {
  // Early return if no price modifier is provided.
  if (!priceModifierType || !priceModifierValue) {
    return variantPrice;
  }

  let result;
  switch (priceModifierType) {
    case 'PERCENTAGE':
      result = variantPrice * (1 - priceModifierValue / 100);
      break;
    case 'AMOUNT':
      result = variantPrice - priceModifierValue;
      break;
    default:
      result = variantPrice;
  }

  // Always round to the nearest penny.
  return Math.round(result * 100) / 100;
};

/**
 * Calculate the price modifier display text.
 * @param {Object} options - The calculation options.
 * @param {string} options.priceModifierType - The type of price modifier ('PERCENTAGE' or 'AMOUNT').
 * @param {number} options.priceModifierValue - The value of the price modifier.
 * @returns {string} The display text for the price modifier.
 */
export const renderPriceModifier = ({ priceModifierType, priceModifierValue }) => {
  if (!priceModifierType || !priceModifierValue) {
    return '';
  }

  switch (priceModifierType) {
    case 'PERCENTAGE':
      return `${priceModifierValue < 0 ? '-' : ''}${Math.abs(priceModifierValue).toFixed(2)}% off`;
    case 'AMOUNT':
      return `${priceModifierValue < 0 ? '-' : ''}£${Math.abs(priceModifierValue).toFixed(2)} off`;
    default:
      return '';
  }
};
